import { CARDISSUE, CARDISSUEANDROID } from './user-docs-links';

export default (): void => {
    const link = navigator.userAgent.match(/Android/i) ? CARDISSUEANDROID : CARDISSUE;

    window.open(link);
};
